module.exports = __webpack_public_path__ + "static/media/intro.ecdeb0c4.mp3";